// The sticky team (Ben, 2026-10-31: "If I select Arsenal Tula in the bio and then later add a squad
// module … it doesn't show the Arsenal Tula squad"). The team picked last — in a search box, dropped
// on a module, picked in a Squad — is what a brand-new team module opens on, as the sticky player
// seeds a new player module. Picking a player clears it: whichever came last wins.

import type { TeamRef } from "../live/team.js";

let sticky: TeamRef | null = null;

export function getStickyTeam(): TeamRef | null {
  return sticky;
}

export function setStickyTeam(team: TeamRef | null): void {
  sticky = team;
}
